import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Reaction, ReactionId, Reactions, ReactionsEnum, Thread, Threads, TimelineItem, TimelineItemType } from "@teammood/timeline";
import { orderBy } from "lodash";
import { MatTooltipModule } from "@angular/material/tooltip";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { ThreadEmoticonReactionsComponent } from "app/frontend/lib/timeline/timeline-item/reaction/thread-emoticon-reactions/thread-emoticon-reactions.component";
import { TmPipesModule } from "app/frontend/lib/shared/util/pipes";
import { EMOTICON_REACTION_DEFS, EmoticonReaction } from "app/frontend/lib/timeline/timeline-item/reaction/emoticon-reactions/emoticon-reaction.type";
import { Task } from "../../../taskbook.types";
import { ReactionService } from "app/frontend/lib/timeline/timeline-item/reaction/reaction.service";

@Component({
    selector: "task-thread-reactions",
    templateUrl: "./task-thread-reactions.component.html",
    styleUrls: ['./task-thread-reactions.component.scss', './../../../../timeline/threads/thread-message/thread-message.component.scss'],
    standalone: true,
    imports: [
        ThreadEmoticonReactionsComponent,
        MatTooltipModule,
        TmPipesModule,
        CommonModule,
        TranslateModule
]
})
export class TaskThreadReactionsComponent implements OnInit{
    
    REACT_OPTIONS = [...EMOTICON_REACTION_DEFS.values()].filter(reaction => reaction.id !== ReactionsEnum.care);
    private _reactions: EmoticonReaction[] 
    protected currentReaction: EmoticonReaction;
    private _timelineItem: TimelineItem & Threads & Reactions;

    @Input({ required: true }) task: Task & Threads & Reactions;
    @Input() thread: Thread;
    @Output() onThreadReactionsUpdated = new EventEmitter<Threads>();

    set reactions(reactions: Reaction[]) {
        if (reactions) {
          this._reactions = orderBy(this.reactionService.mapToEmoticonReactions(reactions), ['count'], ['desc']);
          this.currentReaction = this._reactions.find(reaction => reaction.selected);
        }
    }
    get reactions(): EmoticonReaction[] {
        return this._reactions;
    }
    
    constructor(
        private reactionService: ReactionService
    ) {}

    ngOnInit(): void {
        this.reactions = this.thread.reactions;
    }

    async react(reaction: ReactionId) {
        if (reaction) {
          const taskItem = await this.reactionService.reactToTaskThread(this.task.id, this.task.itemType, this.thread.id, reaction)
          this.onThreadReactionsUpdated.next( taskItem )
          this.reactions = taskItem.threads.find(thread => thread.id === this.thread.id).reactions;
        }
      }
}